<div class="registration-wrapper">

    <div class="modal-dialog modal-dialog-centered registration-modal">
        <div class="modal-content">
            <div class="modal-header">
                <h2 class="modal-title">ثبت نام مالک شناور</h2>
            </div>

            <div class="modal-body">

                <div class="alert alert-warning alert-compact">

                    <p>این طرح صرفاً به‌منظور تخصیص سوخت به دارندگان مجوز صیادی معتبر صادره از سازمان شیلات اجرا
                        می‌گردد. بدیهی است ثبت‌نام افراد فاقد مجوز معتبر، هیچ‌گونه تعهدی برای سازمان شیلات در خصوص تخصیص
                        سوخت ایجاد نخواهد کرد. </p>

                </div>

                <form [formGroup]="formGroup" #form="ngForm" (ngSubmit)="submit()">

                    <div class="row g-2">
                        <!-- phoneNumber field -->
                        <div class="col-md-6">
                            <div class="form-group has-icon"
                                [ngClass]="formGroup.get('strMobile').value ? 'direction-ltr' : ''">
                                <span class="form-control-icon">
                                    <mat-icon>phone_iphone</mat-icon>
                                </span>
                                <input type="text" class="form-control" formControlName="strMobile" inputmode="numeric"
                                    oninput="this.value=this.value.replace(/[^0-9]/g,'')" [placeholder]="mobilePlaceholder" />
                            </div>
                        </div>

                        <!-- nationalId field -->
                        <div class="col-md-6">
                            <div class="form-group has-icon " [ngClass]="formGroup.get('strID').value ? 'direction-ltr' : ''">
                                <span class="form-control-icon">
                                    <mat-icon>badge</mat-icon>
                                </span>
                                <input class="form-control" formControlName="strID" inputmode="numeric" maxlength="10"
                                    oninput="this.value=this.value.replace(/[^0-9]/g,'')" placeholder="* کد ملی مالک شناور" />
                            </div>
                        </div>

                        <!-- name field -->
                        <div class="col-md-6">
                            <div class="form-group has-icon">
                                <span class="form-control-icon">
                                    <mat-icon>account_circle</mat-icon>
                                </span>
                                <input type="text" class="form-control" formControlName="strName" placeholder="* نام"
                                    autofocus />
                            </div>
                        </div>

                        <!-- family field -->
                        <div class="col-md-6">
                            <div class="form-group has-icon">
                                <span class="form-control-icon">
                                    <mat-icon>account_circle</mat-icon>
                                </span>
                                <input type="text" class="form-control" formControlName="strFamily"
                                    placeholder="* نام خانوادگی" />
                            </div>
                        </div>
                    </div>

                    <div class="row g-2 mt-1">
                        <!-- state field -->
                        <div class="col-md-6">
                            <div class="form-group has-icon">
                                <span class="form-control-icon">
                                    <mat-icon>apartment</mat-icon>
                                </span>
                                <select (change)="getCities($event)">
                                    <option [value]="null" disabled selected>* استان</option>
                                    <option *ngFor="let state of states$ | async" [value]="state.strState">{{ state.strStateName
                                        }}</option>
                                </select>
                            </div>
                        </div>

                        <!-- city field -->
                        <div class="col-md-6">
                            <div class="form-group has-icon">
                                <span class="form-control-icon">
                                    <mat-icon>apartment</mat-icon>
                                </span>
                                <select formControlName="strCity">
                                    <option [value]="null" disabled selected>* شهر</option>
                                    <option *ngFor="let city of cities$ | async" [value]="city.strCity">{{ city.strCityName }}
                                    </option>
                                </select>
                            </div>
                        </div>

                        <!-- floating type field -->
                        <div class="col-md-6">
                            <div class="form-group has-icon">
                                <span class="form-control-icon">
                                    <mat-icon>directions_boat</mat-icon>
                                </span>
                                <select formControlName="tiFloatingType">
                                    <option [value]="null" disabled selected>* نوع شناور</option>
                                    <option *ngFor="let floatingType of floatingType$ | async"
                                        [value]="floatingType.tiFloatingType">{{ floatingType.strFloatingType }}</option>
                                </select>
                            </div>
                        </div>

                        <!-- floating power field -->
                        <div class="col-md-6">
                            <div class="form-group has-icon" [ngClass]="formGroup.get('iPower').value ? 'direction-ltr' : ''">
                                <span class="form-control-icon">
                                    <mat-icon>electric_bolt</mat-icon>
                                </span>
                                <input class="form-control" formControlName="iPower" inputmode="numeric"
                                    oninput="this.value=this.value.replace(/[^0-9]/g,'')" placeholder="* توان موتور شناور" />
                            </div>
                        </div>

                        <!-- strLicenseNo field -->
                        <div class="col-md-6">
                            <div class="form-group has-icon">
                                <span class="form-control-icon">
                                    <mat-icon>verified</mat-icon>
                                </span>
                                <input type="text" class="form-control" formControlName="strLicenseNo"
                                    [placeholder]="licenseNoPlaceholder" />

                            </div>
                        </div>

                        <!-- switches: kept side-by-side in the second half of the license row to avoid an extra full row -->
                        <div class="col-md-6">
                            <div class="switch-inline-box">
                                <!-- bHas12DC field -->
                                <div class="form-check form-switch d-flex align-items-center">
                                    <input class="form-check-input m-0" type="checkbox" id="bHas12DC" formControlName="bHas12DC">
                                    <label class="form-check-label pointer text-muted me-2" for="bHas12DC">برق ۱۲/۲۴ ولت</label>
                                </div>

                                <!-- installment field -->
                                <div class="form-check form-switch d-flex align-items-center">
                                    <input class="form-check-input m-0" type="checkbox" id="bInstallment"
                                        formControlName="bInstallment">
                                    <label class="form-check-label pointer text-muted me-2" for="bInstallment">پرداخت اقساطی</label>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- installment down-payment + comment: side-by-side on desktop, stacked on mobile -->
                    <div *ngIf="formGroup.get('bInstallment')?.value" class="row g-2 installment-box">
                        <div class="col-md-6">
                            <div class="form-group has-icon">
                                <label class="mini-label">* پیش پرداخت (ریال)</label>
                                <span class="form-control-icon">
                                    <mat-icon>attach_money</mat-icon>
                                </span>
                                <input class="form-control text-start" formControlName="iPayment1" inputmode="numeric"
                                    oninput="this.value=this.value.replace(/[^0-9]/g,'').toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')" />
                            </div>
                        </div>

                        <div class="col-md-6">
                            <div class="form-group has-icon">
                                <label class="mini-label">* توضیحات شرایط پرداخت </label>

                                <span class="form-control-icon">
                                    <mat-icon>description</mat-icon>
                                </span>
                                <textarea class="form-control" rows="1" formControlName="strPaymentComment"></textarea>
                            </div>
                        </div>
                    </div>

                    <div class="row g-2 mt-1">
                        <!-- map picker field-->
                        <div class="col-12">
                            <div class="form-group has-icon map-field-wrapper">
                                <span class="form-control-icon">
                                    <mat-icon>add_location_alt</mat-icon>
                                </span>

                                <input class="form-control" formControlName="strAddress" [placeholder]='addressPlaceHolder'>

                                <button type="button" class="btn btn-warning show-map-btn" (click)="show_Map()">
                                    <i class="fa fa-map-marker fa-lg" aria-hidden="true"></i>
                                </button>

                                <custom-map *ngIf="showMapDialog" [longLat]="[coordinates.fLon, coordinates.fLat]"
                                    [isOpenModal]="true" (mdl_Submit)="submitMap($event)"></custom-map>
                            </div>
                        </div>

                        <!-- description field -->
                        <div class="col-12">
                            <div class="form-group has-icon mb-0">
                                <span class="form-control-icon">
                                    <mat-icon>description</mat-icon>
                                </span>
                                <textarea class="form-control" rows="2" formControlName="strComment"
                                    placeholder="مثلا: بهترین ساعت حضور کارشناس نصب و توضیحات تکمیلی..."></textarea>
                            </div>
                        </div>
                    </div>

                </form>

            </div>

            <div class="modal-footer d-flex flex-row-reverse justify-content-end">
                <button type="button" class="btn btn-primary"
                    [disabled]="formGroup.invalid || formGroup.pristine || isSubmitDisabled"
                    (click)="form.ngSubmit.emit()">
                    ثبت اطلاعات
                </button>
            </div>
        </div>
    </div>

</div>

<!-- Receipt Dialog -->

<ng-template #paymentReceiptDialog let-modal>

    <ng-container>

        <div class="modal-header">

            <h2 class="modal-title"> ثبت شماره پیگیری فیش پرداختی </h2>

            <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>

        </div>

        <div class="modal-body">

            <form [formGroup]="mdl_Receipt">

                <p class="">شماره پیگیری را دقیقاً مطابق رسید وارد کنید.</p>

                <div class="form-group has-icon"
                    [ngClass]="mdl_Receipt.get('iTrackingCode').value ? 'direction-ltr' : ''">
                    <span class="form-control-icon">
                        <mat-icon>receipt</mat-icon>
                    </span>
                    <input class="form-control" formControlName="iTrackingCode" inputmode="numeric"
                        oninput="this.value=this.value.replace(/[^0-9]/g,'')"
                        placeholder="* شماره پیگیری فیش پرداختی " />
                </div>

                <!-- Deposited Amount -->
                <div class="form-group has-icon" [ngClass]="mdl_Receipt.get('iPayment1').value ? 'direction-ltr' : ''">
                    <span class="form-control-icon">
                        <mat-icon>attach_money</mat-icon>
                    </span>
                    <input class="form-control" formControlName="iPayment1" inputmode="numeric"
                        oninput="this.value=this.value.replace(/[^0-9]/g,'').toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                        placeholder="* مبلغ واریزی (ریال) " />
                </div>
               
                <!-- installment date -->
                <div class="form-group has-icon" [ngClass]="mdl_Receipt.get('strPaymentDate').value ? 'direction-ltr' : ''">
                    <span class="form-control-icon">
                        <mat-icon>date_range</mat-icon>
                    </span>
                    <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false" 
                        [dateGregorianFormat]="'YYYY-MM-DD'" [dateFormat]="'jYYYY/jMM/jDD'" [dateInitValue]="false">
                        <input class="w-100 form-control" formControlName="strPaymentDate"placeholder="تاریخ پرداخت ">
                    </ng-persian-datepicker>
                </div>

                <!-- Car IMEI -->
                <div class="form-group has-icon" [ngClass]="mdl_Receipt.get('strIMEI').value ? 'direction-ltr' : ''">
                    <span class="form-control-icon">
                        <mat-icon>barcode_reader</mat-icon>
                    </span>
                    <input class="form-control" formControlName="strIMEI" inputmode="numeric" maxlength="15"
                        oninput="this.value=this.value.replace(/[^0-9]/g,'')"
                        placeholder="IMEI" />
                </div>

                <!-- gps mobile -->
                <div class="form-group has-icon" [ngClass]="mdl_Receipt.get('strCellNo').value ? 'direction-ltr' : ''">
                    <span class="form-control-icon">
                        <mat-icon>settings_phone</mat-icon>
                    </span>
                    <input class="form-control" formControlName="strCellNo" inputmode="numeric" maxlength="11"
                        oninput="this.value=this.value.replace(/[^0-9]/g,'')"
                        placeholder="شماره سیم کارت دستگاه" />
                </div>

                <!-- installment field -->
                <div class="form-check form-switch my-3 d-flex align-items-center">
                    <input class="form-check-input m-0" type="checkbox" id="hasInstallment"
                        formControlName="bInstallment">
                    <label class="form-check-label pointer text-muted me-2" for="hasInstallment">پرداخت اقساطی</label>
                </div>

                <!-- installment comment -->
                <div *ngIf="mdl_Receipt.get('bInstallment')?.value" class="form-group has-icon">
                    <span class="form-control-icon">
                        <mat-icon>description</mat-icon>
                    </span>
                    <textarea class="form-control" formControlName="strPaymentComment"
                        placeholder="توضیحات شرایط پرداخت ..."></textarea>
                </div>

            </form>

        </div>

        <div class="modal-footer d-flex  justify-content-start">

            <button type="button" class="btn btn-success px-4" (click)="submitReceipt()">

                ثبت اطلاعات

            </button>

            <button class="btn btn-outline-secondary px-4" (click)="modal.dismiss()">

                انصراف

            </button>

        </div>

    </ng-container>

</ng-template>